
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#fff","d":"M22.125 16.593h-1.813v-6.35a.938.938 0 00-.937-.937h-6.987L8.975 5.892a.938.938 0 00-.663-.274h-2.75V1.875h6.05l3.413 3.413a.937.937 0 00.663.274h6.437zm-3.688 5.575H1.875V7.493h6.05l3.412 3.413a.937.937 0 00.663.275h6.437zm-2.361-18.48L12.663.274A.937.937 0 0012 0H4.625a.937.937 0 00-.937.938v4.68H.938A.937.937 0 000 6.555v16.55c0 .519.42.938.938.938h18.437c.517 0 .937-.42.937-.937v-4.638h2.75c.518 0 .938-.42.938-.937V4.625a.937.937 0 00-.938-.938z"}})])
          )
        }
      }
    